module.exports = __webpack_public_path__ + "b747dd387993a29ae7c47175577a2159.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/20-Betsolutions-Sultans-Gift.png
// module id = 1742
// module chunks = 2